import { useEffect, useState } from 'react';
import Header from '../inc/Header'
import Navigation from '../inc/Navigation'
import { isEnableModify } from '../../request/Request';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { success, error } from '../inc/Toast';
import { ToastContainer } from 'react-toastify';
import LoadingPage from '../inc/LoadingPage';
import { deleteNewsletter, getAllNewsletters,softDeleteNewsletter } from "../../../project/services/NewsletterService";


function ListNewsletter() {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    let navigate = useNavigate();
    const navigateToModify = (id) => {
        navigate(process.env.REACT_APP_ADMIN_URL + '/update-NewsLetter/' + id);
    };

    const handleSoftDelete = async (id) => {
        try {
            const success = await softDeleteNewsletter(id);
            if (success) {
            
                window.location.reload();
            }
        } catch (error) {
            // ⚠️ Afficher une alerte en cas d'erreur
            alert("Erreur lors de la suppression de la newsletter.");
        }
    };
  const fetchNewsletters = async () => {
        try {
            const data = await getAllNewsletters('');
            setNews(data);
            setLoading(<LoadingPage/>)
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNewsletters();
    }, []);
    let itemList = [];

    for (let i = 0; i < news.length; i++) {
        itemList.push(
            <><tr key={news[i].id_newsletter}>
                <td className="table-theme">{news[i].id_newsletter}</td>
                <td className="">{news[i].titre}</td>
                <td className="table-date">{news[i].date_sortie}</td>
                {isEnableModify() ? <>
                    <td className="action">
                        {/* <Link to={process.env.REACT_APP_ADMIN_URL + '//' + communiques[i].idactualite}><button type="button" className="btn-axian-fumee btn-space" ><i className="bx bxs-show" ></i></button></Link> */}
                        <button type="button" className="btn-axian-marine btn-space" onClick={() => { navigateToModify(news[i].id_newsletter); }}><i className="bx bxs-edit-alt"></i></button>
                        <button type="button" className="btn-axian-cramoisie-dark btn-space" data-bs-toggle="modal" data-bs-target={"#verticalycentered" + news[i].id_newsletter}><i className="bx bxs-trash-alt"></i></button>
                        <div className="modal fade" id={"verticalycentered" + news[i].id_newsletter} tabindex="-1">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Attention</h5>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        Êtes-vous sûr de vouloir supprimer cette newsletter ?
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
                                        <button type="button" className="btn-axian-cramoisie-light" data-bs-dismiss="modal" onClick={(e) => { handleSoftDelete(news[i].id_newsletter); }} >Supprimer</button>
                                    </div>
                                </div>
                            </div>
                        </div></td></> : <td className="action-solo"></td>}
            </tr></>)
    };

    if (loading) return <LoadingPage/>;
    if (error) return <p>Erreur: {error.message}</p>;

    return (
        <><Header /><Navigation /><ToastContainer /><main id="main" className="main">
            <div className="pagetitle">
                <h1>Newsletters</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to={process.env.REACT_APP_ADMIN_URL + "/dashboard"}>Accueil</Link></li>
                        <li className="breadcrumb-item"><Link to={process.env.REACT_APP_ADMIN_URL + "/list-communique"}>Newsletters</Link></li>
                        <li className="breadcrumb-item active">Liste</li>
                    </ol>
                </nav>
            </div>
            <section className="section">
                <div className="row">

                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <h2 className="card-title">Liste des actualités</h2>
                                <p>
                                    {isEnableModify() ? <Link to={process.env.REACT_APP_ADMIN_URL + "/add-Newsletter"}>
                                        <button type="button" className="btn-axian-charbon">
                                            <i className="bi bi-plus"></i>Nouveau
                                        </button>
                                    </Link> : <div></div>}

                                </p>
                                <div className="table-responsive mt-1">
                                    <table className="table table-striped table-axian">
                                        <thead>
                                            <tr>
                                                <th scope="col">#</th>
                                                <th scope="col">Titre</th>
                                                <th scope="col">Date</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {itemList}
                                        </tbody>
                                    </table>
                                </div>
                                {/* <nav aria-label="Page navigation example">
                                    <ul className="pagination justify-content-end">
                                        {previous}
                                        {pagination}
                                        {next}
                                    </ul>
                                </nav> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main></>
    );
}

export default ListNewsletter;